import React from 'react';


function ScopeOfApplicability() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-2xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Scope of Applicability</h1>

        <div className="space-y-12">
          
          {/* SECTION 1: Applicability Statement */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Applicability Statement</h2>
            <p className="text-gray-800 leading-relaxed">
              AASC Standards are applicable exclusively to the operational layer of Artificial Intelligence service delivery. They govern the configuration, management, and oversight processes employed by entities that deploy AI systems for third parties.
            </p>
          </section>

          {/* SECTION 2: Inclusion */}
          <section className="bg-blue-50 p-6 border-l-4 border-[#2F80ED]">
            <h2 className="text-lg font-bold text-[#2F80ED] mb-4 uppercase tracking-wide">2. Inclusion Criteria</h2>
            <p className="text-[#2F80ED] mb-4 text-sm font-semibold">The standards apply to:</p>
            <ul className="list-disc pl-5 space-y-2 text-[#2F80ED]">
              <li><strong>AI Agencies:</strong> Entities whose primary business is the design and deployment of AI agents.</li>
              <li><strong>Systems Integrators:</strong> Firms that connect AI models to client business infrastructure.</li>
              <li><strong>Managed Service Providers:</strong> Organizations responsible for the ongoing monitoring of AI systems.</li>
              <li><strong>Consultancies:</strong> Firms implementing AI workflows as part of broader advisory services.</li>
            </ul>
          </section>

          {/* SECTION 3: Exclusion */}
          <section className="bg-gray-100 p-6 border-l-4 border-gray-400">
             <h2 className="text-lg font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Exclusion Criteria</h2>
             <p className="text-[#102A43] mb-4 text-sm font-semibold">The standards DO NOT apply to:</p>
             <ul className="list-disc pl-5 space-y-2 text-[#64748B]">
               <li><strong>Software Vendors (SaaS):</strong> Companies selling licenses to pre-packaged software without operational management services.</li>
               <li><strong>Tool Providers:</strong> Vendors of developer tools, prompt libraries, or infrastructure components.</li>
               <li><strong>Educational Institutions:</strong> Entities providing training without commercial deployment.</li>
               <li><strong>Government Regulators:</strong> Public sector enforcement bodies.</li>
             </ul>
          </section>

          {/* SECTION 4: Regulatory Positioning */}
          <section>
             <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Regulatory Positioning</h2>
             <p className="text-gray-800 leading-relaxed mb-4">
               The AASC is a non-governmental standards body. Adherence to these standards is voluntary and does not imply approval by any government agency. The standards are designed to complement, not replace, applicable laws and regulations.
             </p>
          </section>

          {/* SECTION 5: Misclassification */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">5. Misclassification</h2>
            <p className="text-gray-800 leading-relaxed">
              Misclassification of an entity's operational model (e.g., a SaaS vendor claiming status as an Agency) renders any declared alignment void. The Council reserves the right to revoke the status of any entity found to be misrepresenting its business model to claim applicability.
            </p>
          </section>

        </div>
      </div>
    </>
  );
}

export default ScopeOfApplicability;